import { IProductSummary } from "./product-summary.interface";
import { QPilotProduct } from "../../../core/models/qpilot/product.interface";

/**
 * Product List API Response
 * Paginated list of product summaries
 */
export interface IProductListResponse {
  Items: IProductSummary[];
  TotalRecords: number;
  Page: number;
  PageSize: number;
}

/**
 * Product Detail API Response
 * Full product with scheduled order summary
 */
export interface IProductDetailResponse extends QPilotProduct {
  ScheduledOrdersSummary?: {
    ActiveCount: number;
    PausedCount: number;
    FailedCount: number;
    ProcessingCount: number;
    TotalCount: number;
  };
}

/**
 * Bulk Product Action Types
 * Matching old QMC: UpdatePrice, UpdateSalePrice, Delete, SetAllAvailable
 */
export type BulkProductAction =
  | "syncPrices"
  | "syncSalePrices"
  | "delete"
  | "clear";

/**
 * Bulk Product Action Request
 * Note: ProductIds should be ExternalId values (strings), not internal IDs
 */
export interface IBulkProductActionRequest {
  ProductIds: string[];
  Action: Exclude<BulkProductAction, "clear">;
}

/**
 * API Action mapping for bulk operations
 * Maps UI actions to API action strings (matching old QMC)
 */
export const BULK_ACTION_API_MAP: Record<
  Exclude<BulkProductAction, "clear">,
  string
> = {
  syncPrices: "UpdatePrice",
  syncSalePrices: "UpdateSalePrice",
  delete: "Delete",
};

/**
 * Bulk Product Action Response
 */
export interface IBulkProductActionResponse {
  SuccessCount: number;
  FailedCount: number;
  FailedIds?: number[];
  Message?: string;
}

/**
 * Product Sync Request
 */
export interface IProductSyncRequest {
  ProductId: number;
  SiteId: number;
}

/**
 * Product Sync Response
 */
export interface IProductSyncResponse extends QPilotProduct {
  SyncedAt: Date;
  SyncStatus: "success" | "failed" | "partial";
  SyncMessage?: string;
}

/**
 * Product Update Request
 * Partial product for updates
 */
export type IProductUpdateRequest = Partial<QPilotProduct> & {
  Id: number;
  SiteId: number;
};
